// import PropTypes from 'prop-types';
// material-ui
import { fade, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AppLocalizations } from "constants/localization";
import { usesDarkStoreBadge } from "constants/pigments";
import AppStoreBadgeBlack from "assets/AppStoreBadgeBlack.svg";
import AppStoreBadgeWhite from "assets/AppStoreBadgeWhite.svg";
import GooglePlayBadgeBlack from "assets/GooglePlayBadgeBlack.svg";
import GooglePlayBadgeWhite from "assets/GooglePlayBadgeWhite.svg";
import React from "react";
// styles
import styles from "./styles";

const useStyles = makeStyles(styles);

export default function StoreBadges({ secondaryColor, colorKey }) {
  // const [ state, setState ] = React.useState(initialValue);
  const classes = useStyles(styles);
  const dark = usesDarkStoreBadge(colorKey);
  const appStoreBadge = dark ? AppStoreBadgeBlack : AppStoreBadgeWhite;
  const googleBadge = dark ? GooglePlayBadgeBlack : GooglePlayBadgeWhite;

  return (
    <div
      className={classes.root}
      style={{
        color: secondaryColor,
        borderTop: `solid 1px ${fade(secondaryColor, 0.3)}`,
      }}
    >
      <Typography variant="caption">
        {`${AppLocalizations.scoreSharedWith} `}
        <b>
          <i className="fas fa-tennis-ball"></i> Tennis Score Keepr
        </b>
      </Typography>
      <br />
      <Grid container spacing={1} justify="center">
        <Grid item>
          <img
            src={appStoreBadge}
            height="35px"
            alt="AppStoreBadge"
          />
        </Grid>
        <Grid item>
          <img
            src={googleBadge}
            height="35px"
            alt="GooglePlayBadge"
          />
        </Grid>
      </Grid>
    </div>
  );
}
